var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('a',{staticClass:"btn btn-my-primary btn-sm flex-fill",attrs:{"href":_vm.url,"target":"_blank"}},[_c('b-icon',{attrs:{"icon":"link"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }